import ParameterErrors from '../errors/ParameterErrors';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class DistanceHelper {
    static calculateKmFromLatLng(latLng1, latLng2) {
		DistanceHelper._validateLatLng(latLng1, 'latLng1');
		DistanceHelper._validateLatLng(latLng2, 'latLng2');
		const [lat1, lon1]= latLng1;
		const [lat2, lon2]= latLng2;
		const R = 6371e3; // metres
		const φ1 = lat1 * Math.PI/180; // φ, λ in radians
		const φ2 = lat2 * Math.PI/180;
		const Δφ = (lat2-lat1) * Math.PI/180;
		const Δλ = (lon2-lon1) * Math.PI/180;
		const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
				  Math.cos(φ1) * Math.cos(φ2) *
				  Math.sin(Δλ/2) * Math.sin(Δλ/2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
		const d = R * c/1000;
		return d;
    }
	static _validateLatLng(latLng, parameterName){
		if(latLng===undefined||latLng===null)
			throwNotProvided(parameterName);
		if(!Array.isArray(latLng)||(latLng.length!==2))
			throwNotOfType(parameterName, '[number, number]');
	}
}
